module.exports = __webpack_public_path__ + "NoeDisplay-Bold.239d1759534f4559d9eb.otf";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.otf
// module id = ../../../../../src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.otf
// module chunks = styles